<template>
  <div class="wrapper">
    <!-- bg -->
    <!-- <video preload="auto" muted loop id="myVideo">
      <source :src="videoUrl" type="video/mp4" />
    </video> -->

    <!-- hover wrapper -->
    <div class="hover-container" v-if="hover" v:bind="hoveredProject">
      <h1 v-resize-text="{ ratio: 0.56 }"><a href="/">Blue Temple</a></h1>

      <div class="left-container-d-wrapper">
        <div
          class="left-container-d-title-col left-container-d-title-col--r90deg"
        >
          <span class="left-container-title">{{ hoveredProject.name }}</span>
          <span class="left-container-type">{{
            hoveredProject.type.data.name
          }}</span>
        </div>

        <div class="hover-container-d-content">
          <img :src="hoveredProject.cover[1]" />

          <div class="hover-container-d-content">
            <span class="hover-container-location">{{
              hoveredProject.location.data.name
            }}</span>
            <span class="hover-container-chronology">{{
              hoveredProject.year
            }}</span>
            <span class="hover-container-scale">{{
              hoveredProject.scale
            }}</span>
            <span>-</span>
            <span class="hover-container-status">{{
              hoveredProject.status.data.name
            }}</span>
            <span>-</span>
            <p class="hover-container-excerpt">
              {{ hoveredProject.info }}
            </p>
          </div>
        </div>

        <!-- footer social -->
        <div class="footer">
          <!-- Social Icons -->
          <ul class="menu-social">
            <li class="menu-social-item">
              <a
                :href="'mailto:' + socialUrls.email"
                class="menu-social-item--email"
                ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    d="M464 64H48a48 48 0 00-48 48v288a48 48 0 0048 48h416a48 48 0 0048-48V112a48 48 0 00-48-48zm0 32c2.2 0 4.2.5 6.1 1.2L256 282.8 41.9 97.2c1.9-.8 4-1.2 6.1-1.2h416zm0 320H48a16 16 0 01-16-16V131l213.5 185a16.1 16.1 0 0021 0L480 131v269a16 16 0 01-16 16z"
                  /></svg
              ></a>
            </li>
            <li class="menu-social-item">
              <a
                :href="socialUrls.ig"
                target="_blank"
                class="menu-social-item--instagram"
                ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511 511">
                  <path
                    d="M510.5 150.2a186.4 186.4 0 00-11.9-62 125.6 125.6 0 00-29.5-45.3 124.9 124.9 0 00-45.2-29.4 187 187 0 00-62-11.9C334.5.3 325.8 0 256.4 0s-78.1.3-105.3 1.5a186.4 186.4 0 00-62 11.9 125.1 125.1 0 00-45.3 29.5 124.9 124.9 0 00-29.4 45.2 187 187 0 00-11.9 62C1.2 177.5.9 186.1.9 255.5s.3 78.1 1.5 105.3c1.2 27.2 5.6 45.8 11.9 62a127 127 0 0029.5 45.3c12.8 13 28.3 23.1 45.2 29.4a187 187 0 0062 11.9c27.2 1.2 35.9 1.5 105.3 1.5s78.1-.3 105.3-1.5c27.2-1.2 45.8-5.6 62-11.9a130.9 130.9 0 0074.8-74.8 187 187 0 0011.9-62c1.2-27.3 1.5-35.9 1.5-105.3s-.1-77.9-1.3-105.2zm-46 208.7c-1.1 25-5.3 38.4-8.8 47.4a84.9 84.9 0 01-48.5 48.5c-9 3.5-22.6 7.7-47.4 8.8-27 1.2-35 1.5-103.2 1.5s-76.4-.3-103.2-1.5c-25-1.1-38.4-5.3-47.4-8.8a77.6 77.6 0 01-29.3-19.1 80 80 0 01-19.1-29.3c-3.5-9-7.7-22.6-8.8-47.4-1.2-27-1.5-35-1.5-103.2s.3-76.4 1.5-103.2c1.1-25 5.3-38.4 8.8-47.4a75.6 75.6 0 0119.1-29.4A80 80 0 01106 56.7c9-3.5 22.6-7.7 47.4-8.8 27-1.2 35-1.5 103.2-1.5 68.3 0 76.4.3 103.2 1.5 25 1.1 38.4 5.3 47.4 8.8a77.6 77.6 0 0129.3 19.1c8.5 8.3 15 18.3 19.1 29.4 3.5 9 7.7 22.6 8.8 47.4 1.2 27 1.5 35 1.5 103.2s-.2 76.1-1.4 103.1z"
                  />
                  <path
                    d="M256.4 124.3a131.3 131.3 0 100 262.6 131.3 131.3 0 000-262.6zm0 216.4a85.2 85.2 0 110-170.4 85.2 85.2 0 010 170.4zM423.6 119.1a30.6 30.6 0 11-61.2 0 30.6 30.6 0 0161.2 0z"
                  /></svg
              ></a>
            </li>
            <li class="menu-social-item">
              <a
                :href="socialUrls.fb"
                target="_blank"
                class="menu-social-item--facebook"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 682.7 682.7"
                >
                  <path
                    d="M625.7 21H56.3A35.3 35.3 0 0021 56.3v569.4A35.3 35.3 0 0056.3 661h306.5V413.5h-83.1v-96.9h83.1v-71.3c0-82.7 50.5-127.7 124.2-127.7 35.3 0 65.7 2.6 74.5 3.8v86.4h-50.9c-40.1 0-47.9 19.1-47.9 47.1v61.7h95.9l-12.5 96.9h-83.4V661h162.8a35.3 35.3 0 0035.3-35.3V56.3A35 35 0 00625.7 21z"
                  />
                </svg>
              </a>
            </li>
            <li class="menu-social-item">
              <a
                :href="socialUrls.li"
                target="_blank"
                class="menu-social-item--linkedin"
                ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 510 510">
                  <path
                    d="M459 0H51C23 0 0 22.9 0 51v408c0 28 23 51 51 51h408c28 0 51-23 51-51V51c0-28.1-23-51-51-51zM153 433.5H76.5V204H153v229.5zm-38.2-272.9c-25.5 0-45.9-20.4-45.9-45.9s20.4-45.9 45.9-45.9 45.9 20.4 45.9 45.9-20.5 45.9-45.9 45.9zm318.7 272.9H357V298.4c0-20.4-17.9-38.2-38.2-38.2s-38.2 17.9-38.2 38.2v135.1H204V204h76.5v30.6a82.5 82.5 0 0163.8-35.7 90.3 90.3 0 0189.2 89.3v145.3z"
                  /></svg
              ></a>
            </li>
          </ul>
          <router-link
            to="/getinvolved"
            class="get-involved-cta get-involved-cta--white"
            >get involved</router-link
          >
        </div>
      </div>
    </div>
    <!-- /hover -->

    <!-- intro p -->
    <div class="projects--list-extras">
      <p>
        {{ searchText }}
      </p>

      <!-- search -->
      <input
        type="text"
        class="search-bar"
        name="search"
        v-model="search"
        placeholder="Search"
      />
    </div>

    <!-- Project List -->
    <ul class="projects projects--grid">
      <!-- wide grid info-->
      <li class="projects-item projects-info">
        <div class="projects-wide">
          <h4 class="projects-chronology">Chronology</h4>
          <h3 class="projects-title">Name</h3>
          <h4 class="projects-scale">Scale</h4>
          <h4 class="projects-region">Region</h4>
          <h4 class="projects-program">Program</h4>
        </div>
      </li>

      <!-- First Project Item - Featured PROJECT  -->
      <li
        class="projects-item"
        v-for="project in featuredProject"
        :key="project.id"
        v-on:mouseover="isMobile ? null : displayHoverInfo($event, project)"
        v-on:mouseleave="isMobile ? null : mouseleavethumb()"
      >
        <router-link v-bind:to="'/project/' + project.slug">
          <div class="projects-col">
            <div
              class="projects-img"
              v-bind:style="{
                'background-image': 'url(' + project.animation + ')'
              }"
            ></div>
            <h3 class="projects-title">{{ project.name }}</h3>
            <h4 class="projects-scale">{{ project.scale }}</h4>
            <h4 class="projects-program">{{ project.type.data.name }}</h4>
            <h4 class="projects-chronology">{{ project.year }}</h4>
            <h4 class="projects-region">{{ project.location.data.name }}</h4>
          </div>
          <div class="projects-col">
            <h4 class="projects-chronology">{{ project.year }}</h4>
            <h4 class="projects-region">{{ project.location.data.name }}</h4>
          </div>
          <!-- list wide -->
          <div class="projects-wide">
            <h4 class="projects-chronology">{{ project.year }}</h4>
            <h3 class="projects-title">{{ project.name }}</h3>
            <h4 class="projects-scale">{{ project.scale }}</h4>
            <h4 class="projects-region">{{ project.location.data.name }}</h4>
            <h4 class="projects-program">{{ project.type.data.name }}</h4>
          </div>
        </router-link>
      </li>

      <!-- Project Item axios -->
      <li
        class="projects-item"
        v-for="project in filteredProjects"
        :key="project.id"
        @mouseover="isMobile ? null : displayHoverInfo($event, project)"
        @mouseleave="isMobile ? null : mouseleavethumb()"
      >
        <router-link v-bind:to="'/project/' + project.slug">
          <div class="projects-col">
            <div
              class="projects-img"
              v-bind:style="{
                'background-image': 'url(' + project.animation + ')'
              }"
            ></div>
            <h3 class="projects-title">{{ project.name }}</h3>
            <h4 class="projects-scale">{{ project.scale }}</h4>
            <h4 class="projects-program">{{ project.type.data.name }}</h4>
            <h4 class="projects-chronology">{{ project.year }}</h4>
            <h4 class="projects-region">{{ project.location.data.name }}</h4>
          </div>
          <div class="projects-col">
            <h4 class="projects-chronology">{{ project.year }}</h4>
            <h4 class="projects-region">{{ project.location.data.name }}</h4>
          </div>
          <!-- list wide -->
          <div class="projects-wide">
            <h4 class="projects-chronology">{{ project.year }}</h4>
            <h3 class="projects-title">{{ project.name }}</h3>
            <h4 class="projects-scale">{{ project.scale }}</h4>
            <h4 class="projects-region">{{ project.location.data.name }}</h4>
            <h4 class="projects-program">{{ project.type.data.name }}</h4>
          </div>
        </router-link>
      </li>

      <!-- Last Project Item - ADD PROJECT  -->
      <li
        class="projects-item projects-item--addproject"
        v-on:mouseover="isMobile ? null : toggleBgVideo(false)"
        v-on:mouseleave="isMobile ? null : toggleBgVideo(true)"
      >
        <router-link to="/addproject">
          <div class="projects-col">
            <div class="projects-img"></div>
            <h3 class="projects-title">ADD PROJECT</h3>
            <h4 class="projects-scale">---</h4>
            <h4 class="projects-program">---</h4>
          </div>
          <div class="projects-col">
            <h4 class="projects-chronology">---</h4>
            <h4 class="projects-region">---</h4>
          </div>
          <!-- list wide -->
          <div class="projects-wide">
            <h4 class="projects-chronology">FUTURE</h4>
            <h3 class="projects-title">ADD PROJECT</h3>
            <h4 class="projects-scale">---</h4>
            <h4 class="projects-region">---</h4>
            <h4 class="projects-program">---</h4>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { bus } from "../main";
import axios from "axios";
import ResizeText from "vue-resize-text";

export default {
  name: "HomeProjects",
  props: {
    msg: String
  },
  directives: {
    ResizeText
  },
  data() {
    return {
      isMobile: false,
      hover: false,
      projects: [],
      originalOrderProjects: [],
      sortedProjects: [],
      hoveredProject: [],
      search: "",
      searchText: "",
      featuredProject: [],
      socialUrls: [],
      videoUrl: ""
    };
  },
  mounted() {
    var self = this;

    this.fetchData();

    // get the search text from config api
    axios
      .get("https://api.blue-temple.com/configuration")
      .then(function(res) {
        var searchTextObj = res.data.data.filter(obj => {
          return obj.key === "SEARCH_TEXT";
        });
        self.searchText = searchTextObj[0]["defaultValue"];
      })
      .catch(function(error) {
        console.log("Error", error);
      });

    // social networks
    this.getSocialNetworks();

    // start bg video
    console.log("mounted");
    if (!this.isMobile) {
      this.autoplayVideo();
    }

    // window.addEventListener("load", () => {
    //   console.log("loadd");
    //   if (!this.isMobile) {
    //     this.autoplayVideo();
    //   }
    // });
  },
  computed: {
    filteredProjects: function() {
      return this.sortedProjects.filter(project => {
        return (
          project.name.toLowerCase().match(this.search.toLowerCase()) ||
          project.info.toLowerCase().match(this.search.toLowerCase()) ||
          project.goal.toLowerCase().match(this.search.toLowerCase()) ||
          project.concept.toLowerCase().match(this.search.toLowerCase())
        );
      });
    }
  },
  methods: {
    fetchData() {
      var self = this;
      axios
        .get(
          "https://api.blue-temple.com/projects?_with=status,location,type,tag"
        )
        .then(function(res) {
          // get the featured project
          self.featuredProject = res.data.data.filter(obj => {
            return obj.tag.data.slug === "featured";
          });

          // get all projects without featured
          self.projects = res.data.data.filter(obj => {
            return obj.tag.data.slug !== "featured";
          });
          // original order copy for reset filters
          self.originalOrderProjects = res.data.data.filter(obj => {
            return obj.tag.data.slug !== "featured";
          });
          self.sortedProjects = self.projects.sort((a, b) =>
            a.year > b.year ? -1 : null
          );
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    },
    getSocialNetworks() {
      var self = this;

      axios
        .get("https://api.blue-temple.com/configuration")
        .then(function(res) {
          var fb_url = res.data.data.filter(obj => {
            return obj.key === "Social_Facebook";
          });
          self.socialUrls.fb = fb_url[0].defaultValue;

          var ig_url = res.data.data.filter(obj => {
            return obj.key === "Social_Instagram";
          });
          self.socialUrls.ig = ig_url[0].defaultValue;

          var li_url = res.data.data.filter(obj => {
            return obj.key === "Social_Linkedin";
          });
          self.socialUrls.li = li_url[0].defaultValue;

          var email_url = res.data.data.filter(obj => {
            return obj.key === "Social_Mail";
          });
          self.socialUrls.email = email_url[0].defaultValue;
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    },
    sortby(data) {
      console.log("data: " + data.prop + data.tag);

      if (data.prop && data.tag) {
        if (data.prop === "region") {
          this.projects.sort((a, b) => (a[data.prop] < b[data.prop] ? -1 : 1));
        } else {
          // this.projects.sort((a, b) => (a[data.prop] < b[data.prop] ? 1 : -1));
        }

        // sort by chronology
        if (data.prop === "chronology") {
          this.sortedProjects = this.projects.filter(obj => {
            return obj.year === data.tag;
          });
        }

        // sort by scale
        if (data.prop === "scale") {
          this.sortedProjects = this.projects.filter(obj => {
            return obj.scale === data.tag;
          });
        }

        // sort by program
        if (data.prop === "program") {
          this.sortedProjects = this.projects.filter(obj => {
            return obj.type.data.name === data.tag;
          });
        }

        // sort by region
        if (data.prop === "region") {
          this.sortedProjects = this.projects.filter(obj => {
            return obj.location.data.name === data.tag;
          });
        }

        if (data.prop === "name") {
          // console.log(this.originalOrderProjects);
          // this.sortedProjects = this.originalOrderProjects;
          this.sortedProjects = this.projects.sort((a, b) =>
            a.year > b.year ? -1 : null
          );
        }

        //
        // this.sortedProjects = this.projects.filter(obj => {
        //   return (
        //     obj.tag.data.slug === data.tag.replace(/\s+/g, "-").toLowerCase()
        //   );
        // });
        // set visible text to grid elements

        // handle the text-under-icon change
        if (document.querySelector(".projects--grid")) {
          document
            .querySelector(".projects--grid")
            .setAttribute("data-filter", data.prop);
        }
      } else {
        if (document.querySelector(".projects--grid")) {
          document
            .querySelector(".projects--grid")
            .setAttribute("data-filter", data.prop);
        }

        if (data.prop === "chronology") {
          this.sortedProjects = this.projects.sort((a, b) =>
            a.year > b.year ? -1 : null
          );
        }

        if (data.prop === "scale") {
          this.sortedProjects = this.projects.sort((a, b) =>
            a.scale < b.scale ? -1 : 1
          );
        }

        if (data.prop === "program") {
          this.sortedProjects = this.projects.sort((a, b) =>
            a.type.data.name < b.type.data.name ? -1 : 1
          );
        }

        if (data.prop === "region") {
          this.sortedProjects = this.projects.sort((a, b) =>
            a.location.data.name < b.location.data.name ? 1 : -1
          );
        }

        if (data.prop === "name") {
          // console.log(this.originalOrderProjects);
          this.sortedProjects = this.originalOrderProjects;
        }
      }
    },
    mq() {
      this.isMobile = window.matchMedia("(max-width: 1024px)").matches;
    },
    displayHoverInfo(event, project) {
      this.hover = true;
      this.hoveredProject = project;
      // this.toggleBgVideo(!this.hover);
    },
    mouseleavethumb() {
      this.hover = false;
      // this.toggleBgVideo(!this.hover);
    },
    autoplayVideo() {
      // get video url
      var self = this;
      axios
        .get("https://api.blue-temple.com/")
        .then(function(res) {
          self.videoUrl = res.data.mediaFiles.homepage_1;

          // const video = document.querySelector("#myVideo");
          // console.log(video.duration);
          // console.log(
          //   "random starting time of video: " +
          //     Math.floor(Math.random() * video.duration) +
          //     1
          // );

          // console.log("here");

          // video.load();
          // video.style.visibility = "hidden";
          // video.pause();
          // video.addEventListener(
          //   "loadeddata",
          //   function() {
          //     // Video is loaded and can be played
          //     video.currentTime = Math.floor(
          //       Math.random() * video.duration + 1
          //     );
          //     video.play();
          //     setTimeout(() => {
          //       video.style.visibility = "visible";
          //     }, 500);
          //   },
          //   false
          // );
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    },
    toggleBgVideo(bool) {
      const video = document.querySelector("#myVideo");

      // fix bug when returning (click back) from other pages
      console.log(this.videoUrl);
      if (this.videoUrl === "") {
        this.autoplayVideo();
      }

      if (bool) {
        video.play();
      } else {
        video.pause();
      }
    }
  },
  metaInfo() {
    console.log("THIS", this);
    return {
      meta: [
        {
          name: "description",
          content: "Architecture studio based in Myanmar."
        }
      ]
    };
  },
  created() {
    bus.$on("sorted", data => {
      this.sortby(data);
    });
    //
    this.mq();
    window.addEventListener("resize", this.mq);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.mq);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrapper {
  display: block;
  width: 100%;

  @media screen and (max-width: 759px) {
    position: relative;
    z-index: 9;
  }

  video {
    display: none;
  }

  .search-bar {
    display: block;
    width: 35vw;
    margin: 15px auto 20px;
    padding: 13px;
    font-family: "rajdhaniregular";
    font-size: 16px;
    text-align: right;
    color: $color-light;
    border: 0;
    background: rgba(255, 255, 255, 0.3);
  }

  ::-webkit-input-placeholder {
    /* Edge */
    font-family: "rajdhaniregular";
    font-size: 16px;
    color: $color-light;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    font-family: "rajdhaniregular";
    font-size: 16px;
    color: $color-light;
  }

  ::placeholder {
    font-family: "rajdhaniregular";
    font-size: 16px;
    color: $color-light;
  }

  p {
    display: block;
    width: calc(100% - 40px);
    // max-width: 320px;
    margin: 20px auto 0;
    font-family: "rajdhaniregular";
    font-size: 14px;
    font-weight: normal;
    line-height: 18px;
    color: $color-light;
  }
}

.projects {
  .projects-wide {
    display: none;
  }

  &--grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: calc(100% - 40px);
    // max-width: 320px;
    margin: 20px auto 0;

    .projects-info {
      display: none;
    }

    /* filter toggle visible text */
    &[data-filter="chronology"] {
      .projects-item:not(.projects-item--addproject) {
        .projects-col {
          h4,
          h3:not(.projects-chronology) {
            display: none;
          }

          .projects-chronology:first-child {
            display: block;
          }
        }
      }
    }

    &[data-filter="scale"] {
      .projects-item:not(.projects-item--addproject) {
        .projects-col {
          h4,
          h3:not(.projects-scale) {
            display: none;
          }

          .projects-scale {
            display: block;
          }
        }
      }
    }

    &[data-filter="program"] {
      .projects-item:not(.projects-item--addproject) {
        .projects-col {
          h4,
          h3:not(.projects-program) {
            display: none;
          }

          .projects-program {
            display: block;
          }
        }
      }
    }

    &[data-filter="region"] {
      .projects-item:not(.projects-item--addproject) {
        .projects-col:first-child {
          h4,
          h3:not(.projects-region) {
            display: none;
          }

          .projects-region {
            display: block;
          }
        }
      }
    }
  }

  &-item {
    display: block;
    margin-bottom: 15px;

    &--addproject {
      .projects-img {
        background-image: url("../assets/images/bt-animation-last.png");
      }
    }

    &:hover {
      cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
    }

    a {
      position: relative;
      width: 100%;
      text-decoration: none;
      padding: 12px 0;

      &:hover {
        cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
      }
    }
  }

  &-img {
    display: block;
    width: 150px;
    height: 150px;
    margin-bottom: 11px;
    // background-image: url("../assets/images/project_icon_1.png");
    background-size: cover;
    background-position: 0 0;
  }

  &-title,
  &-scale,
  &-program,
  &-chronology,
  &-region {
    display: none;
    font-family: "rajdhanimedium";
    font-size: 14px;
    font-weight: normal;
    color: $color-lightgrey-title;
    text-align: center;
  }

  &-title {
    display: block;
  }

  &--list-extras {
    display: none;

    &--visible {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      z-index: 990;

      p {
        max-width: 30vw !important;
        margin-right: 18vw;
      }
    }
  }

  &--list {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: calc(100% - 40px);
    // max-width: 320px;
    margin: 20px auto 0;
    z-index: 90;

    .projects-scale,
    .projects-program,
    .projects-chronology,
    .projects-region,
    .projects-title {
      display: block;
    }

    .projects-info {
      display: none;

      .projects-scale,
      .projects-program,
      .projects-chronology,
      .projects-region,
      .projects-title {
        display: block;
        padding: 0 0 12px;
        text-align: left;
        color: $color-light;
      }

      .projects-title {
        width: 40%;
      }

      .projects-program,
      .projects-region {
        width: 20%;
      }

      .projects-scale,
      .projects-chronology {
        width: 10%;
      }
    }

    .projects-col + .projects-col {
      text-align: right;
    }

    .projects-item {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      margin: 0;
      padding: 0 3.1vw;

      @media screen and (max-width: 759px) {
        padding: 0;
      }

      a {
        &:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 1px;
          background: $color-lightgrey-title;
        }
      }

      &:hover:not(.projects-info) {
        background: $color-light;

        * {
          cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
        }

        + .projects-item a:before {
          background: transparent;
        }

        a:before,
        a:after {
          background: $color-light;
        }

        .projects-scale,
        .projects-program,
        .projects-chronology,
        .projects-region,
        .projects-title {
          color: $color-dark;
        }
      }

      .project-chronology {
        order: 1;
      }

      &:last-child {
        a:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 1px;
          background: $color-lightgrey-title;
        }
      }
    }

    .projects-img {
      display: none;
    }
  }
}

@media screen and (max-width: 759px) {
  // .projects {
  //   &--grid {
  //     &::after {
  //       content: none;
  //       display: none;
  //     }
  //   }
  // }

  .projects {
    &--grid {
      .projects-title {
        text-align: center;
      }
    }

    &--list-extras {
      flex-direction: column;

      p,
      .search-bar {
        width: calc(100% - 40px);
        margin: 20px auto 0;
        text-align: left;
      }

      p {
        order: 2;
        max-width: 100% !important;
      }

      input {
        order: 1;
      }
    }

    &-info {
      display: none !important;
    }
  }
}

@media screen and (min-width: 768px) {
  .wrapper {
    video {
      display: block;
      position: fixed;
      right: 0;
      bottom: 0;
      min-width: 100%;
      min-height: 100%;
    }

    p {
      max-width: 100%;
      font-family: "rajdhaniregular";
      font-size: 14px;
      line-height: 18px;
    }
  }

  .projects {
    &--grid {
      width: 100%;
      max-width: 100%;
      margin: 0 auto;
      padding: 3.1vw;
      justify-content: flex-start;

      // &::after {
      //   content: "";
      //   flex: auto;
      // }

      .projects-title {
        text-align: center;
      }
    }

    &-img {
      width: 170px;
      height: 170px;
      background-image: url("../assets/images/project_icon_1.png");
      background-size: cover;
      background-position: 0 0;

      &:hover {
        animation: play 5.1s steps(141) infinite;
        cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;

        @keyframes play {
          from {
            background-position: 0 0;
          }
          to {
            background-position: 0 -23970px;
          }
        }
      }
    }

    &--list {
      max-width: 100%;
      margin: 20px auto 0;

      &-extras {
        padding: 22px 22px 0;

        .search-bar,
        p {
          margin-top: 0;
        }
      }

      .projects-item {
        padding: 0;
      }

      .projects-info {
        display: flex;
        border-top: 0;

        .projects-chronology,
        .projects-scale,
        .projects-program,
        .projects-region,
        .projects-title {
          font-family: "rajdhanimedium";
          text-transform: uppercase;
        }

        .projects-chronology,
        .projects-scale {
          width: 15%;
        }

        .projects-title,
        .projects-program,
        .projects-region {
          width: 20%;
        }
      }

      .projects-col {
        display: none;
      }

      .projects-wide {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .projects-scale,
        .projects-region,
        .projects-chronology {
          width: 15%;
          text-align: left;
        }

        .projects-program {
          width: 20%;
          text-align: left;
        }

        .projects-title {
          width: 30%;
          text-align: left;
        }

        .projects-program {
          text-align: right;
        }

        // .projects-region,
        // .projects-program,
        // .projects-scale,
        // .projects-chronology {
        //   width: 15%;
        // }
      }
    }

    &-item {
      width: 33.3%;

      .projects-img {
        margin-right: auto;
        margin-left: auto;
      }
    }
  }

  /* Hover */
  .hover-container {
    position: absolute;
    top: 0;
    left: 0;
    // display: none;
    width: calc(25vw + 2px);
    height: 100vh;
    padding: 22px;
    background: white;
    z-index: 100;
    border-top: 2px solid $color-darkgrey;
    border-bottom: 2px solid $color-darkgrey;
    border-left: 2px solid $color-darkgrey;

    h1 {
      font-size: 3.5vw;
      color: $color-darkgrey;
    }

    img {
      width: 100%;
      min-height: 84px;
      margin-top: 0;
      background-color: $color-darkgrey;
    }

    &-title {
      display: block;
      font-family: "rajdhanibold";
      font-size: 18px;
      color: $color-darkgrey;
    }

    &-type {
      display: block;
      margin-bottom: 30px;
      font-family: "rajdhaniregular";
      font-size: 18px;
      color: $color-darkgrey;
    }

    &-scale,
    &-location,
    &-chronology,
    &-status {
      display: block;
      font-family: "rajdhaniregular";
      font-size: 14px;
      color: $color-darkgrey;
    }

    p.hover-container-excerpt {
      display: block;
      margin: 0;
      font-family: "rajdhaniregular";
      font-size: 14px;
      color: $color-darkgrey;
    }

    &-status {
      font-family: "rajdhanibold";
      text-transform: uppercase;
    }
  }
}

/* */
@media screen and (min-width: 1024px) {
  .hover-container {
    position: fixed;
    padding: 3.1vw;
  }

  .projects {
    &--list {
      width: 100%;
      margin: 20px 0 0;

      &-extras {
        padding: 3.1vw 3.1vw 0;
      }

      .projects-item {
        padding: 0 3.1vw;
      }
    }

    &-wide {
      // padding: 0 40px;
    }

    &-item {
      width: 16.6%;
    }
  }
}

/* desktop */
@media screen and (min-width: 1440px) {
  .hover-container {
    padding: 3.1vw;

    img {
      min-height: 165px;
      max-height: 208px;
      margin-top: 0;
      object-fit: cover;
    }

    &-title,
    &-type {
      font-size: 38px;
      line-height: 40px;
    }

    p.hover-container-excerpt {
      width: 100%;
    }

    &-d-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
    }

    &-d-title-col {
      margin-left: -5px;
      margin-right: 3.1vw;
      writing-mode: vertical-rl;
      text-orientation: mixed;
      transform: rotate(-180deg);
    }

    &-d-content {
      margin-top: 0;
    }
  }
}
</style>
